<template>
<div>
    <h3>Level 1 - NES Nostalgia</h3>

    <div v-if="openModalWindow">
        <popup :artworks="artworks" :imageindex="imageIndex" :closemodal="cancelImageModel"></popup>
    </div>

    <div class="content-wrapper">
        <div class="content">
            <h2 class="content-head">Level 1 - NES Nostalgia</h2>

            <div class="pure-g">
                <div v-for="(artwork, index) in artworks">
                    <div :id="artwork-index"class="photo-box u-1 u-med-1-3 u-lrg-1-5"
                        v-on:click="openImageModel(index)"
                        v-on:mouseenter="showAnimated($event)"
                        v-on:mouseleave="showThumbnail($event)"
                    >
                            <img class="list-img loading-img thumb-img"
                                :data-normal="artwork.thumb"
                                height="250px"
                                width="250px"
                            >
                            <img class="list-img loading-img animated-img"
                                :data-normal="artwork.img"
                                height="250px"
                                width="250px"
                            >
                    </div>

                    <div class="artwork-info">
                        <div class="game-name">{{ artwork.title }}</div>

                        <div v-for="artist in artwork.info">
                            <div class="game-author"><a :href="artist.link" target="_blank">{{ artist.author }}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="footer l-box">
            &copy; 2016 All Rights Reserved. Do not use without contacting Back to Bits for permission. Images may not be used without permission of the artist(s).
        </div>
    </div>

</div>

</template>

<script>

import Popup from '@/components/Popup';
import Layzr from 'layzr.js'

const instance = Layzr();
const cloudFrontUrl = 'http://dxt3s73uon4yn.cloudfront.net/images/';

export default {
    name: 'Dashboard',
    components: {
        Popup
    },
    mounted() {
            instance
                .update()           // track initial elements
                .check()            // check initial elements
                .handlers(true)     // bind scroll and resize handlers

    },
    data () {
        return {
            openModalWindow: false,
            artworks: [
                {
                    gameName: "01 Zelda 2 (Link)",
                    title: "Dungeon Crawl",
                    img: cloudFrontUrl + "01_Zelda_2_Jay_Quercia_01/01_Zelda_2_Jay_Quercia_01.gif",
                    thumb: cloudFrontUrl + "01_Zelda_2_Jay_Quercia_01/01_Zelda_2_Jay_Quercia_01.jpg",
                    fileLocaton: "01_Zelda_2_Jay_Quercia_01",
                    info: [
                        {
                            author: "Jay Quercia",
                            link: "http://jayquercia.tumblr.com"
                        }
                    ],
                    rank: 0
                },
                { 
                    gameName: "02 Zelda 2 (Dark Link)",
                    title: "Dungeon Crawl",
                    img: cloudFrontUrl + "02_Zelda_2_Jay_Quercia_02/02_Zelda_2_Jay_Quercia_02.gif",
                    thumb: cloudFrontUrl + "02_Zelda_2_Jay_Quercia_02/02_Zelda_2_Jay_Quercia_02.jpg",
                    info: [
                        {
                            author: "Jay Quercia",
                            link: "http://jayquercia.tumblr.com"
                        }
                    ],
                    rank: 1
                },
                { 
                    gameName: "03 Super Mario Bros 2",
                    title: "Sweet Dreams",
                    img: cloudFrontUrl + "03_SMB2_Mike Horowitz/03_SMB2_Mike Horowitz.gif",
                    thumb: cloudFrontUrl + "03_SMB2_Mike Horowitz/03_SMB2_Mike Horowitz.jpg",
                    info: [
                        {
                            author: "Mike Horowitz",
                            link: "http://mikejwitz.com"
                        }
                    ],
                    rank: 2
                },                       
                { 
                    gameName: "04 Mega Man 3 ",
                    title: "Boy in Blue",
                    img: cloudFrontUrl + "04_Megaman_3_Eddie_Song/04_Megaman_3_Eddie_Song.gif",
                    thumb: cloudFrontUrl + "04_Megaman_3_Eddie_Song/04_Megaman_3_Eddie_Song.jpg",
                    info: [
                        {
                            author: "Eddie Song",
                            link: "http://eddiesong.com"
                        }
                    ],
                    rank: 3
                }, 
                { 
                    gameName: "05 Nintendo World Cup",
                    title: "Kick it!",
                    img: cloudFrontUrl + "05_NintendoWorldCup_David_and_Aleksander/05_NintendoWorldCup_David_and_Aleksander.gif",
                    thumb: cloudFrontUrl + "05_NintendoWorldCup_David_and_Aleksander/05_NintendoWorldCup_David_and_Aleksander.jpg",
                    info: [
                        {
                            author: "David Pocull (Illustration)",
                            link: "http://www.pocull.com"                    
                        },
                        {
                            author: "Aleksander Saharovsky (Animation)",
                            link: "http://www.alek.work"
                        }
                    ],
                    rank: 4
                },
                { 
                    gameName: "06 Balloon Figh",
                    title: "First Flight",
                    img: cloudFrontUrl + "06_Balloon_Fight_Phil_Borst/06_Balloon_Fight_Phil_Borst.gif",
                    thumb: cloudFrontUrl + "06_Balloon_Fight_Phil_Borst/06_Balloon_Fight_Phil_Borst.jpg",
                    info: [
                        {
                            author: "Phil Borst",
                            link: "http://philborst.com"
                        }
                    ],
                    rank: 5
                },
                { 
                    gameName: "07 Joust",
                    title: "The Burdens of War",
                    img: cloudFrontUrl + "07_Joust_Craig_Kohlmeyer/07_Joust_Craig_Kohlmeyer.gif",
                    thumb: cloudFrontUrl + "07_Joust_Craig_Kohlmeyer/07_Joust_Craig_Kohlmeyer.jpg",
                    info: [
                        {
                            author: "Craig Kohlmeyer",
                            link: "http://craigkohlmeyer.com"
                        }
                    ],
                    rank: 6
                },
                { 
                    gameName: "08 Gauntlet",
                    title: "I Need a Hero",
                    img: cloudFrontUrl + "08_Gauntlet_Jerry_Liu/08_Gauntlet_Jerry_Liu.gif",
                    thumb: cloudFrontUrl + "08_Gauntlet_Jerry_Liu/08_Gauntlet_Jerry_Liu.jpg",
                    info: [
                        {
                            author: "Jerry Liu",
                            link: "http://www.jerryliustudio.com"
                        }
                    ],
                    rank: 7
                },                         
                { 
                    gameName: "09 Castlevania",
                    title: "Enemy Drops",
                    img: cloudFrontUrl + "09_Castlevania_Andres_Olle/09_Castlevania_Andres_Olle.gif",
                    thumb: cloudFrontUrl + "09_Castlevania_Andres_Olle/09_Castlevania_Andres_Olle.jpg",
                    info: [
                        {
                            author: "Andres Rivera (Illustration)",
                            link: "http://Supawerk.com"
                        },
                        {
                            author: "Olle Engstrom (Animation)",
                            link: "http://www.olleengstrom.tv"
                        }
                    ],
                    rank: 8
                },
                { 
                    gameName: "10 Mega Man",
                    title: "Hard Hat Problems",
                    img: cloudFrontUrl + "10_Mega_Man_Greg_Gunn/10_Mega_Man_Greg_Gunn.gif",
                    thumb: cloudFrontUrl + "10_Mega_Man_Greg_Gunn/10_Mega_Man_Greg_Gunn.jpg",
                    info: [
                        {
                            author: "Greg Gunn",
                            link: "http://ggunn.com"
                        }
                    ],
                    rank: 9
                },          
                { 
                    gameName: "720",
                    title: "Tribute to 720",
                    img: cloudFrontUrl + "720_Rachel_Yonda/720_Rachel_Yonda_PSD.gif",
                    thumb: cloudFrontUrl + "720_Rachel_Yonda/720_Rachel_Yonda.jpg",
                    info: [
                        {
                            author: "Rachel Yonda",
                            link: "https://twitter.com/rachelyonda"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Adventures of Lolo",
                    title: "Lolo Meets Leeper",
                    img: cloudFrontUrl + "Adventures_of_Lolo_Mary_Varn/Adventures_of_Lolo_Mary_Varn.gif",
                    thumb: cloudFrontUrl + "Adventures_of_Lolo_Mary_Varn/Adventures_of_Lolo_Mary_Varn.jpg",
                    info: [
                        {
                            author: "Mary Varn",
                            link: "http://maryvarn.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Bomberman",
                    title: "Inspired by Bomberman",
                    img: cloudFrontUrl + "Bomberman_Tony_Salih/Bomberman_Tony_Salih.gif",
                    thumb: cloudFrontUrl + "Bomberman_Tony_Salih/Bomberman_Tony_Salih.jpg",
                    info: [
                        {
                            author: "Tony Bui (Design)",
                            link: "http://tonybuifanclub.com"
                        },
                        {
                            author: "Salih Abdul-Karim (Animation)",
                            link: "http://salih.tv"
                        }                
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Burger Time",
                    title: "Burger NO Time",
                    img: cloudFrontUrl + "Burger_Time_Rocket_Panda/Burger_Time_Rocket_Panda.gif",
                    thumb: cloudFrontUrl + "Burger_Time_Rocket_Panda/Burger_Time_Rocket_Panda.jpg",
                    info: [
                        {
                            author: "Riccardo Rocketpanda Albertini",
                            link: "http://www.therocketpanda.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Donkey Kong",
                    title: "Lunch Break",
                    img: cloudFrontUrl + "Donkey_Kong_Catalina_Rodriguez/Donkey_Kong_Catalina_Rodriguez.gif",
                    thumb: cloudFrontUrl + "Donkey_Kong_Catalina_Rodriguez/Donkey_Kong_Catalina_Rodriguez.jpg",
                    info: [
                        {
                            author: "Catalina Rodriguez",
                            link: "http://catalinar.tv"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Double Dragon",
                    title: "Inspired by Double Dragon",
                    img: cloudFrontUrl + "Double_Dragon_Marco_Giampaolo/Double_Dragon_Marco_Giampaolo.gif",
                    thumb: cloudFrontUrl + "Double_Dragon_Marco_Giampaolo/Double_Dragon_Marco_Giampaolo.jpg",
                    info: [
                        {
                            author: "Marco Giampaolo",
                            link: "http://hellomarcog.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Dr. Mario",
                    title: "Inspired by Dr. Mario",
                    img: cloudFrontUrl + "Dr_Mario_Kris_Merc/Dr_Mario_Kris_Merc.gif",
                    thumb: cloudFrontUrl + "Dr_Mario_Kris_Merc/Dr_Mario_Kris_Merc.jpg",
                    info: [
                        {
                            author: "Kris Merc",
                            link: "http://krismerc.tv"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Dragon Quest",
                    title: "Triple Slime Attack",
                    img: cloudFrontUrl + "Dragon_Quest_Gerald_Soto/Dragon_Quest_Gerald_Soto_PSD.gif",
                    thumb: cloudFrontUrl + "Dragon_Quest_Gerald_Soto/Dragon_Quest_Gerald_Soto.jpg",
                    info: [
                        {
                            author: "Gerald Mark Soto",
                            link: "http://www.geraldmarksoto.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Duck Hunt",
                    title: "Anatomy of a Murder",
                    img: cloudFrontUrl + "DuckHunt_Salih_Beau/DuckHunt_Salih_Beau.gif",
                    thumb: cloudFrontUrl + "DuckHunt_Salih_Beau/DuckHunt_Salih_Beau.jpg",
                    info: [
                        {
                            author: "Beau Monroe (Design)",
                            link: "http://beaumonroe.com"
                        },
                        {
                            author: "Salih Abdul-Karim (Animation)",
                            link: "http://salih.tv"
                        }                
                    ],
                    rank: "random"
                },
                { 
                    gameName: "DuckTales",
                    title: "Shake Your Tail Feathers!",
                    img: cloudFrontUrl + "DuckTales_Sara_Bennett/DuckTales_Sara_Bennett.gif",
                    thumb: cloudFrontUrl + "DuckTales_Sara_Bennett/DuckTales_Sara_Bennett.jpg",
                    info: [
                        {
                            author: "Sara Bennett",
                            link: "https://vimeo.com/shabello"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Earthbound",
                    title: "Holy Loly Mountain",
                    img: cloudFrontUrl + "Earthbound_Michelle_Ouellette/Earthbound_Michelle_Ouellette.gif",
                    thumb: cloudFrontUrl + "Earthbound_Michelle_Ouellette/Earthbound_Michelle_Ouellette.jpg",
                    info: [
                        {
                            author: "Michelle Oullette",
                            link: "http://yeahhaus.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Excitebike",
                    title: "Not so Excite Bike",
                    img: cloudFrontUrl + "Excite_Bike_Stubbs/Excite_Bike_Stubbs.gif",
                    thumb: cloudFrontUrl + "Excite_Bike_Stubbs/Excite_Bike_Stubbs.jpg",
                    info: [
                        {
                            author: "Stubbs Johnston",
                            link: "http://www.stubbs.tv"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Fester’s Quest",
                    title: "Fester VS. The Aliens?",
                    img: cloudFrontUrl + "Festers_Quest_Cole_Roberts/Festers_Quest_Cole_Roberts.gif",
                    thumb: cloudFrontUrl + "Festers_Quest_Cole_Roberts/Festers_Quest_Cole_Roberts.jpg",
                    info: [
                        {
                            author: "Cole Roberts",
                            link: "http://coleswork.com "
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Kirby’s Adventure",
                    title: "Kirby Bounce",
                    img: cloudFrontUrl + "Kirbys_Adventure_Caitlin_Cadieux/Kirbys_Adventure_Caitlin_Cadieux.gif",
                    thumb: cloudFrontUrl + "Kirbys_Adventure_Caitlin_Cadieux/Kirbys_Adventure_Caitlin_Cadieux.jpg",
                    info: [
                        {
                            author: "Caitlin Cadieux",
                            link: "http://caitcadieux.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Lemmings",
                    title: "Lemmeight by Eight",
                    img: cloudFrontUrl + "Lemmings_Jorge_Canedo/Lemmings_Jorge_Canedo.gif",
                    thumb: cloudFrontUrl + "Lemmings_Jorge_Canedo/Lemmings_Jorge_Canedo.jpg",
                    info: [
                        {
                            author: "Jorge Canedo",
                            link: "http://jrcanest.co"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Mega Man 2",
                    title: "Pixel Dream",
                    img: cloudFrontUrl + "Mega_Man_2_Thomas_Heckel/Mega_Man_2_Thomas_Heckel.gif",
                    thumb: cloudFrontUrl + "Mega_Man_2_Thomas_Heckel/Mega_Man_2_Thomas_Heckel.jpg",
                    info: [
                        {
                            author: "Thomas Heckel",
                            link: "http://thomas-heckel.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Metroid",
                    title: "Stargazer",
                    img: cloudFrontUrl + "Metroid_Andrew_Kolb/Metroid_Andrew_Kolb.gif",
                    thumb: cloudFrontUrl + "Metroid_Andrew_Kolb/Metroid_Andrew_Kolb.jpg",
                    info: [
                        {
                            author: "Andrew Kolb",
                            link: "http://www.kolbisneat.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Mike Tyson’s Punchout",
                    title: "Tyson Punch Out Tyson",
                    img: cloudFrontUrl + "Mike_Tysons_Punchout_Chad_Thompson/Mike_Tysons_Punchout_Chad_Thompson.gif",
                    thumb: cloudFrontUrl + "Mike_Tysons_Punchout_Chad_Thompson/Mike_Tysons_Punchout_Chad_Thompson.jpg",
                    info: [
                        {
                            author: "Chad Thompson",
                            link: "http://yeahhaus.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Ninja Gaiden",
                    title: "Inspired by Ninja Gaiden",
                    img: cloudFrontUrl + "Ninja_Gaiden_Morgan_James/Ninja_Gaiden_Morgan_James.gif",
                    thumb: cloudFrontUrl + "Ninja_Gaiden_Morgan_James/Ninja_Gaiden_Morgan_James.jpg",
                    info: [
                        {
                            author: "Morgan C. James",
                            link: "http://morgancjames.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Pacman",
                    title: "Power Up!",
                    img: cloudFrontUrl + "Pacman_James_Boorman/Pacman_James_Boorman.gif",
                    thumb: cloudFrontUrl + "Pacman_James_Boorman/Pacman_James_Boorman.jpg",
                    info: [
                        {
                            author: "James Boorman",
                            link: "http://www.jamesboorman.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Paperboy",
                    title: "Courier of Chaos",
                    img: cloudFrontUrl + "Paperboy_Joe_Moccia/Paperboy_Joe_Moccia.gif",
                    thumb: cloudFrontUrl + "Paperboy_Joe_Moccia/Paperboy_Joe_Moccia.jpg",
                    info: [
                        {
                            author: "Joe Moccia",
                            link: "http://www.joe-moccia.com"
                        }
                    ],
                    rank: "random"
                },
                    { 
                    gameName: "Rampage",
                    title: "Lizzie & George",
                    img: cloudFrontUrl + "Rampage_Oliver_Sin/Rampage_Oliver_Sin.gif",
                    thumb: cloudFrontUrl + "Rampage_Oliver_Sin/Rampage_Oliver_Sin.jpg",
                    info: [
                        {
                            author: "Oliver Sin",
                            link: "http://www.oliversin.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "R.C. Pro-Am",
                    title: "I Am A Big Fan of Radio Control",
                    img: cloudFrontUrl + "RC_ProAm_Yussef_Cole/RC_ProAm_Yussef_Cole_64.gif",
                    thumb: cloudFrontUrl + "RC_ProAm_Yussef_Cole/RC_ProAm_Yussef_Cole_64.jpg",
                    info: [
                        {
                            author: "Yussef Cole",
                            link: "http://yussefcole.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Super Mario Bros 3",
                    title: "Raccoon Mario!",
                    img: cloudFrontUrl + "SMB3_Greg_Lee/SMB3_Greg_Lee.gif",
                    thumb: cloudFrontUrl + "SMB3_Greg_Lee/SMB3_Greg_Lee.jpg",
                    info: [
                        {
                            author: "Greg Hahn Lee",
                            link: "http://Greghahnlee.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Spy Hunter",
                    title: "Weapons Check",
                    img: cloudFrontUrl + "Spy_Hunter_Marco_Ruesta/Spy_Hunter_Marco_Ruesta.gif",
                    thumb: cloudFrontUrl + "Spy_Hunter_Marco_Ruesta/Spy_Hunter_Marco_Ruesta.jpg",
                    info: [
                        {
                            author: "Jean Marco Ruesta",
                            link: "http://jeanruesta.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Tetris 2",
                    title: "TETRABODY DYNAMICS",
                    img: cloudFrontUrl + "Tetris_2_Nicolas_Girard/Tetris_2_Nicolas_Girard.gif",
                    thumb: cloudFrontUrl + "Tetris_2_Nicolas_Girard/Tetris_2_Nicolas_Girard.jpg",
                    info: [
                        {
                            author: "Nicolas Girard",
                            link: "http://nicolas.to"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Tetris",
                    title: "Four Shapes",
                    img: cloudFrontUrl + "Tetris_Carlo_Vega/Tetris_Carlo_Vega.gif",
                    thumb: cloudFrontUrl + "Tetris_Carlo_Vega/Tetris_Carlo_Vega.jpg",
                    info: [
                        {
                            author: "Carlo Vega",
                            link: "https://www.instagram.com/carlovega"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "The Legend of Kage",
                    title: "A Happy Run At The Park",
                    img: cloudFrontUrl + "The_Legend_of_Kage_Bryan_Cobonpue/The_Legend_of_Kage_Bryan_Cobonpue.gif",
                    thumb: cloudFrontUrl + "The_Legend_of_Kage_Bryan_Cobonpue/The_Legend_of_Kage_Bryan_Cobonpue.jpg",
                    info: [
                        {
                            author: "Bryan Cobonpue",
                            link: "http://www.bryancobonpue.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "The Legend of Zelda",
                    title: "Hyrule's Finest",
                    img: cloudFrontUrl + "The_Legend_of_Zelda_Nick_Pattern/The_Legend_of_Zelda_Nick_Pattern.gif",
                    thumb: cloudFrontUrl + "The_Legend_of_Zelda_Nick_Pattern/The_Legend_of_Zelda_Nick_Pattern.jpg",
                    info: [
                        {
                            author: "Nick Patten",
                            link: "https://vimeo.com/188243895"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Marble Madness",
                    title: "The Life and Death of a Marble",
                    img: cloudFrontUrl + "Marble_Madness_Dave_Pryor/Marble_Madness_Dave_Pryor.gif",
                    thumb: cloudFrontUrl + "Marble_Madness_Dave_Pryor/Marble_Madness_Dave_Pryor.jpg",
                    info: [
                        {
                            author: "Dave Pryor",
                            link: "https://www.davepryor72.blogspot.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Blaster Master",
                    title: "Blastin’",
                    img: cloudFrontUrl + "Blaster_Master_Jerry_Liu/Blaster_Master_Jerry_Liu.gif",
                    thumb: cloudFrontUrl + "Blaster_Master_Jerry_Liu/Blaster_Master_Jerry_Liu.jpg",
                    info: [
                        {
                            author: "Jerry Liu",
                            link: "http://www.jerryliustudio.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "Final Fanstasy",
                    title: "Warriors of Light",
                    img: cloudFrontUrl + "Final_Fantasy_Chris_Fung/Final_Fantasy_Chris_Fung_PSD.gif",
                    thumb: cloudFrontUrl + "Final_Fantasy_Chris_Fung/Final_Fantasy_Chris_Fung.jpg",
                    info: [
                        {
                            author: "Christopher Fung",
                            link: "http://www.mrfung.com"
                        }
                    ],
                    rank: "random"
                },
                { 
                    gameName: "TMNT 2",
                    title: "Cowabunga",
                    img: cloudFrontUrl + "TMNT_2_Jason_Yang/TMNT_2_Jason_Yang_GG.gif",
                    thumb: cloudFrontUrl + "TMNT_2_Jason_Yang/TMNT_2_Jason_Yang.jpg",
                    info: [
                        {
                            author: "Jason Yang",
                            link: "http://www.invisibleelement.com"
                        }
                    ],
                    rank: "random"
                }
            ]
        }
    },
    methods: {

        openImageModel(index) {
            this.openModalWindow = true;
            this.imageIndex = index;
        },

        showAnimated(e) {
            e.currentTarget.lastElementChild.src = e.target.lastElementChild.src;
            this.toggleImages(e.currentTarget, true);
        },

        showThumbnail(e) {
            this.toggleImages(e.currentTarget, false);
        },

        toggleImages(ele, gif) {
            ele.firstElementChild.style.visibility = gif ? 'hidden' : 'visible';
            ele.lastElementChild.style.visibility = gif ? 'visible' : 'hidden';
        },
        cancelImageModel() {
            this.openModalWindow = false;
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home-container {
    z-index: 1;
    overflow: hidden;
    width: 100%;
    height: 88%;
    top: 0;
    left: 0;
    position: fixed !important;
}


h3 {
  font-size: 24px;
  color: #f21852;
}

.photo-box {
  margin: 10px 15px 10px 0;
  cursor: pointer;
  position: relative;
}

.photo-box img.loading-img {
  background: transparent url(data:image/gif;base64,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);
  background-size: contain;
}

.photo-box img.animated-img {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
}

.artwork-info {
  margin-bottom: 30px;
  max-width: 200px;
}

.artwork-info .game-name {
  color: #f21852;
  margin-bottom: 5px;
  font-weight: bold;
}

.artwork-info .game-author {
  margin-bottom: 5px;
}

.artwork-info .game-author a {
  text-decoration: none;
  color: #333;
}

.artwork-info .game-author a:hover {
  text-decoration: underline;
  color: #666;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue